import { rootApi } from '../../user/api';

// Define a service using a base URL and expected endpoints
const apiWithTag = rootApi.enhanceEndpoints({
  addTagTypes: ['ReasonMasters', 'ReasonMasterForm'],
});

export const reasonMasterApi = apiWithTag.injectEndpoints({
  endpoints: (builder) => ({
    findAllReasonMasterDisplay: builder.query({
      query: () => `reasons/display/`,
      keepUnusedDataFor: 0,
      providesTags: ['ReasonMasterForm'],
    }),

    findAllReasonMasters: builder.query({
      query: () => `reasons/`,
      providesTags: ['ReasonMasters'],
    }),
    findReasonMasterById: builder.query({
      query: (id) => `reasons/${id}`,
      providesTags: (result, error, arg) => {
        return result
          ? [{ type: 'ReasonMasters', id: result.id }]
          : ['ReasonMasters'];
      },
    }),
    findSubjectReasonMasterById: builder.query({
      query: (id) => `reasons/?subject_reason=${id}`,
      providesTags: (result, error, arg) => {
        return result
          ? [{ type: 'ReasonMasterForm', id: result.id }]
          : ['ReasonMasterForm'];
      },
    }),

    findAllOrderReasonMasters: builder.query({
      query: (payload) => {
        let url = `reasons/?`;
        let param = '';
        Object.keys(payload).forEach((key) => {
          if (payload[key] != null) {
            param += `&${key}=${payload[key]}`;
          }
        });
        return { url: url + param };
      },
      providesTags: ['ReasonMasters'],
    }),

    findReasonMasterByModule: builder.query({
      query: (module) => `reasons/?module=${module}`,
      providesTags: (result, error, arg) => {
        return result
          ? [{ type: 'ReasonMasters', module: result.module }]
          : ['ReasonMasters'];
      },
    }),
    createReasonMaster: builder.mutation({
      query: (reasonMaster) => ({
        url: `reasons/`,
        method: 'POST',
        body: reasonMaster,
      }),
      providesTags: (result, error, arg) => {
        return result
          ? [{ type: 'ReasonMasterForm', id: result.id }]
          : ['ReasonMasterForm'];
      },
      invalidatesTags: ['ReasonMasterForm'],
    }),
    updateReasonMaster: builder.mutation({
      query: (reasonMaster) => ({
        url: `reasons/${reasonMaster.id}/`,
        method: 'PATCH',
        body: reasonMaster,
      }),
      invalidatesTags: ['ReasonMasterForm'],
    }),
    deleteReasonMaster: builder.mutation({
      query: (reasonMaster) => ({
        url: `reasons/${reasonMaster.id}`,
        method: 'DELETE',
      }),
      invalidatesTags: ['ReasonMasterForm'],
    }),
    findAllGroupReasons: builder.query({
      query: () => `group_reasons/`,
      providesTags: ['ReasonMasterForm'],
    }),
    findAllGroupReasonsMaxCode: builder.query({
      query: () => `group_reasons/max_code/`,
      providesTags: ['ReasonMasterForm'],
    }),
    findGroupReasonById: builder.query({
      query: (id) => `group_reasons/${id}`,
      providesTags: (result, error, arg) => {
        return result
          ? [{ type: 'ReasonMasterForm', id: result.id }]
          : ['ReasonMasterForm'];
      },
    }),
    createGroupReason: builder.mutation({
      query: (groupReason) => ({
        url: `group_reasons/`,
        method: 'POST',
        body: groupReason,
      }),
      invalidatesTags: ['ReasonMasters'],
    }),
    updateGroupReason: builder.mutation({
      query: (groupReason) => ({
        url: `group_reasons/${groupReason.id}/`,
        method: 'PATCH',
        body: groupReason,
      }),
      invalidatesTags: ['ReasonMasterForm'],
    }),
    deleteGroupReason: builder.mutation({
      query: (groupReason) => ({
        url: `group_reasons/${groupReason.id}`,
        method: 'DELETE',
      }),
      invalidatesTags: ['ReasonMasterForm'],
    }),
    findAllModuleReasons: builder.query({
      query: () => `module_reasons/`,
      providesTags: ['ReasonMasters'],
    }),
    findModuleReasonById: builder.query({
      query: (id) => `module_reasons/${id}`,
      providesTags: (result, error, arg) => {
        return result
          ? [{ type: 'ReasonMasters', id: result.id }]
          : ['ReasonMasters'];
      },
    }),
    createModuleReason: builder.mutation({
      query: (moduleReason) => ({
        url: `module_reasons/`,
        method: 'POST',
        body: moduleReason,
      }),
      invalidatesTags: ['ReasonMasters'],
    }),
    updateModuleReason: builder.mutation({
      query: (moduleReason) => ({
        url: `module_reasons/${moduleReason.id}/`,
        method: 'PATCH',
        body: moduleReason,
      }),
      invalidatesTags: ['ReasonMasterForm'],
    }),
    deleteModuleReason: builder.mutation({
      query: (moduleReason) => ({
        url: `module_reasons/${moduleReason.id}`,
        method: 'DELETE',
      }),
      invalidatesTags: ['ReasonMasterForm'],
    }),
    findAllSubjectReasons: builder.query({
      query: () => `subject_reasons/`,
      providesTags: ['ReasonMasters'],
    }),
    findAllSubjectReasonsMaxCode: builder.query({
      query: (id) => `subject_reasons/max_code/?group_code=${id}`,
      providesTags: (result, error, arg) => {
        return result
          ? [{ type: 'ReasonMasterForm', id: result.id }]
          : ['ReasonMasterForm'];
      },
    }),
    findSubjectReasonById: builder.query({
      query: (id) => `subject_reasons/${id}`,
      providesTags: (result, error, arg) => {
        return result
          ? [{ type: 'ReasonMasters', id: result.id }]
          : ['ReasonMasters'];
      },
    }),
    createSubjectReason: builder.mutation({
      query: (subjectReason) => ({
        url: `subject_reasons/`,
        method: 'POST',
        body: subjectReason,
      }),
      invalidatesTags: ['ReasonMasterForm'],
    }),
    updateSubjectReason: builder.mutation({
      query: (subjectReason) => ({
        url: `subject_reasons/${subjectReason.id}/`,
        method: 'PATCH',
        body: subjectReason,
      }),
      invalidatesTags: ['ReasonMasterForm'],
    }),
    deleteSubjectReason: builder.mutation({
      query: (subjectReason) => ({
        url: `subject_reasons/${subjectReason.id}`,
        method: 'DELETE',
      }),
      invalidatesTags: ['ReasonMasterForm'],
    }),
  }),
});

// Export hooks for usage in functional components, which are
// auto-generated based on the defined endpoints
export const {
  useFindAllReasonMastersQuery,
  useFindAllReasonMasterDisplayQuery,
  useFindReasonMasterByIdQuery,
  useFindSubjectReasonMasterByIdQuery,
  useFindReasonMasterByModuleQuery,
  useCreateReasonMasterMutation,
  useUpdateReasonMasterMutation,
  useDeleteReasonMasterMutation,
  //Module
  useFindAllModuleReasonsQuery,
  useFindModuleReasonByIdQuery,
  useCreateModuleReasonMutation,
  useUpdateModuleReasonMutation,
  useDeleteModuleReasonMutation,
  //Group
  useFindAllGroupReasonsQuery,
  useFindAllGroupReasonsMaxCodeQuery,
  useFindGroupReasonByIdQuery,
  useCreateGroupReasonMutation,
  useUpdateGroupReasonMutation,
  useDeleteGroupReasonMutation,
  //Subject
  useFindAllSubjectReasonsQuery,
  useFindAllSubjectReasonsMaxCodeQuery,
  useFindSubjectReasonByIdQuery,
  useCreateSubjectReasonMutation,
  useUpdateSubjectReasonMutation,
  useDeleteSubjectReasonMutation,
} = reasonMasterApi;
